import { render, staticRenderFns } from "./allocationClient.vue?vue&type=template&id=1e54f2aa&"
import script from "./allocationClient.vue?vue&type=script&lang=js&"
export * from "./allocationClient.vue?vue&type=script&lang=js&"
import style0 from "./allocationClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports